"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Helper_1 = require("../Helper");
const DropDown_1 = __importDefault(require("./DropDown"));
class DropDownGroup {
    constructor(_root) {
        this.root = _root;
        this.initialize();
    }
    initialize() {
        if ((0, Helper_1.isNil)(this.root)) {
            return;
        }
        const dropDownElements = Array.from(this.root.querySelectorAll(".neos-dropdown-trigger"));
        dropDownElements.forEach((_element) => {
            new DropDown_1.default(this.root, _element, true);
        });
    }
}
exports.default = DropDownGroup;
